import React, { useEffect } from 'react';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import message from '@src/components/common-message';

class MainStore extends BaseStore {

  @observable contentId = '';

  // // 文章标题
  @observable article_title = '';

  // 文章内容
  @observable content = '';

  /**
   * 获取文章详细信息
   * @param {string} contentId - 文章ID
   */
  getArticleDetail = async contentId => {
    try {
      const { content } = await this.$ztService.getArticleDetail({ contentId });

      // /**
      //  * 设置文章标题
      //  * @param {string} title - 文章标题
      //  */
      this.article_title = content.title;
      // /**
      //  * 设置文章内容
      //  * @param {string} content - 文章内容
      //  */
      this.content = content.content;

    } catch (error) {
      message.fail(error?.message);
    }
  };

  use() {
    super.use();
    const urlParams = new URLSearchParams(window.location.search);
    this.contentId = urlParams.get('contentId');

    useMount(() => {
      // 测试contentID: slsaa5curksh
      if (this.contentId) {
        this.getArticleDetail(this.contentId);
      } else {
        message.fail('未提供contentId参数',3000);
      }
    });
  }
}

export default MainStore;
